import { render } from "./BodyMoveGame.vue?vue&type=template&id=4328a65a&scoped=true"
import script from "./BodyMoveGame.vue?vue&type=script&lang=js"
export * from "./BodyMoveGame.vue?vue&type=script&lang=js"

import "./BodyMoveGame.vue?vue&type=style&index=0&id=4328a65a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4328a65a"]])

export default __exports__